import MuiCircularProgress, {
  type CircularProgressProps,
} from '@mui/material/CircularProgress';

export type { CircularProgressProps };

const CircularProgress = (props: CircularProgressProps) => (
  <MuiCircularProgress {...props} />
);

export default CircularProgress;
